/**
 * 主播端的着陆页
 * @author zhenn
 * @createTime 2017-10-23
 */

import React from 'react';
import TopbarNav from '../common/topbar-nav';
import StepNav from './step-nav';
// 三个step对应的页面
import Step1 from './step1';
import Step2 from './step2';
import Step3 from './step3';

import ProjectAddPb from '../../pb/giftitemadd.pb';
import ProjectEditPb from '../../pb/giftitemedit.pb';
// import ProjectListPb from '../../pb/giftitemlist.pb';
import { giftService } from '../../config';

import './create-item.less';

// { itemName, itemDesc, giftList }
const addProject = giftService('/gift/item/add', ProjectAddPb.Gift.ItemAdd);
const editProject = giftService('/gift/item/edit', ProjectEditPb.Gift.ItemEdit);
// const getProjectList = giftService('/gift/item/list', ProjectListPb.Gift.ItemList);

class CreateItem extends React.Component {
    constructor(props) {
        super(props);
        const { match } = props;
        this.state = {
            step: Number(match.params.step),
            itemId: match.params.id,
            //  存储所有第一步保存的信息，在第二部的时候展示
            itemName: '',
            itemDesc: '',
            selected: [],
            //  显示在tabnav左边的工具
            leftTool: 'close',
            giftList: []
        };
    }

    componentDidMount() {
        const { id, step } = this.props.match.params;
        //  第一步没有传id，就检查项目列表，确认是否显示关闭按钮，这个后面需要放到step1
        // if (Number(step) === 1) {
        //     if (!id) {
        //         this.checkProjectLength();
        //     }
        // }
    }

    //  第一步提交信息
    onCommitInfo = (data, callback) => {
        const { itemId, itemName, itemDesc, giftList } = data;
        const me = this;
        if (!itemId) {
            addProject({ itemName, itemDesc, giftList, itemType: 2 })
                .then((data) => {
                    callback && callback();
                    if (!data || !data.itemId) {
                        return UG.simple(UG.lang.template('Dashboard failed to create.'));
                    }
                    let itemId = longToString(data.itemId);
                    me.setState({ itemId, itemName, itemDesc, selected: giftList });
                    UG.simple(UG.lang.template('Dashboard created!'));
                    UG.router.push(`/createitem/2/${itemId}`);
                })
                .catch(err => {
                    callback && callback();
                    if (Number(err) === 98307) {
                        return UG.simple(UG.lang.template('This name has been used'));
                    }
                    UG.simple(UG.lang.template('Dashboard failed to create.'));
                    console.log(err);
                });
        } else {
            // itemId, itemName, itemDesc, giftIdList
            editProject({ itemId, itemName, itemDesc, giftList })
                .then((data) => {
                    callback && callback();
                    //   修改成功以后不会有任何的返回值
                    me.setState({ itemId, itemName, itemDesc, selected: giftList });
                    UG.simple(UG.lang.template('Dashboard updated!'));
                    UG.router.push(`/createitem/2/${itemId}`);
                })
                .catch(err => {
                    callback && callback();
                    UG.simple(UG.lang.template('Dashboard failed to update;('));
                    console.log(err);
                });
        }
    };

    //  第二步，第三步后退
    onBack = () => {
        const { step } = this.state;
        UG.router.push(`/createitem/${step - 1}/${this.props.match.params.id}`);
    };

    //  第二部分copy链接，或者是下一步的按钮
    onNextToComplete = () => {
        UG.router.push(`/createitem/3/${this.props.match.params.id}`);
    };

    //  如果项目的列表长度为0 ，就显示创建的页面
    // checkProjectLength() {
    //     getProjectList({ pageNum: 1, pageSize: 20 })
    //         .then(data => {
    //             if (!data || data.length === 0) {
    //                 this.setState({ leftTool: 'null' });
    //             }
    //         })
    //         .catch(err => {
    //             console.log(err);
    //             this.setState({ leftTool: 'null' });
    //         });
    // }

    goToProjectList = () => {
        UG.router.push('/project');
    };

    goToCreateProject = () => {
        UG.router.push(`/createitem/1`);
    };

    render() {
        const { step, itemId, giftList, leftTool } = this.state;
        let stepComp = <Step1
            id={itemId}
            onCommit={this.onCommitInfo}
            giftList={giftList}/>;
        if (step === 2) {
            stepComp = <Step2
                id={itemId}
                onEdit={this.onBack}
                onNext={this.onNextToComplete}
                onSeeAll={UG.router.push.bind(null, '/project')}/>;
        } else if (step === 3) {
            stepComp = <Step3
                onCreateMore={this.goToCreateProject}
                onCheckRevenue={this.goToProjectList}/>;
        }

        return (
            <div className="create-item">
                {/* 全局头部 */}
                <TopbarNav
                    bordered
                    onClose={this.goToProjectList}
                    onBack={this.onBack}
                    leftTool={step === 1 ? leftTool : 'back'}
                    title={UG.lang.template('Create Dashboard')}/>
                <StepNav step={step}/>
                {stepComp}
            </div>
        );
    }
}

export default CreateItem;



// WEBPACK FOOTER //
// ./js/host/gift/create-item.js